import { render, staticRenderFns } from "./stock-page.vue?vue&type=template&id=df047d88"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df047d88')) {
      api.createRecord('df047d88', component.options)
    } else {
      api.reload('df047d88', component.options)
    }
    module.hot.accept("./stock-page.vue?vue&type=template&id=df047d88", function () {
      api.rerender('df047d88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EndUserViews/Stock/stock-page.vue"
export default component.exports